import React from 'react';

export type DesignStartMode = 'preconfigured' | 'custom';

export const DesignStartChooser: React.FC<{
  value?: DesignStartMode;
  templateImageUrl?: string;
  onChange: (mode: DesignStartMode) => void;
}> = ({ value, templateImageUrl, onChange }) => (
  <section aria-labelledby="design-start-title" className="space-y-3">
    <div>
      <h3 id="design-start-title" className="font-semibold text-gray-900">How would you like to start?</h3>
      <p className="text-xs text-gray-500">Use a proven design or create your own at the exact selected print size.</p>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <button type="button" aria-pressed={value === 'preconfigured'} onClick={() => onChange('preconfigured')}
        className={`text-left border-2 rounded-lg overflow-hidden ${value === 'preconfigured' ? 'border-emerald-600 ring-2 ring-emerald-100' : 'border-gray-200 hover:border-gray-300'}`}>
        {templateImageUrl ? <img src={templateImageUrl} alt="Selected preconfigured design" className="w-full h-28 object-contain bg-gray-50" /> : <div className="h-28 bg-gray-50 grid place-items-center text-3xl">▣</div>}
        <div className="p-3"><strong className="text-sm">Preconfigured design</strong><p className="text-xs text-gray-500 mt-1">Start with the original layout and personalize it.</p></div>
      </button>
      <button type="button" aria-pressed={value === 'custom'} onClick={() => onChange('custom')}
        className={`text-left border-2 rounded-lg overflow-hidden ${value === 'custom' ? 'border-emerald-600 ring-2 ring-emerald-100' : 'border-gray-200 hover:border-gray-300'}`}>
        <div className="h-28 bg-white grid place-items-center border-b border-dashed border-gray-200 text-3xl">＋</div>
        <div className="p-3"><strong className="text-sm">Build your own</strong><p className="text-xs text-gray-500 mt-1">Open a blank, product-accurate canvas with a suggested QR.</p></div>
      </button>
    </div>
  </section>
);
